import { render, staticRenderFns } from "./LayoutBasic.vue?vue&type=template&id=5f93ec4f&"
import script from "./LayoutBasic.vue?vue&type=script&lang=js&"
export * from "./LayoutBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f93ec4f')) {
      api.createRecord('5f93ec4f', component.options)
    } else {
      api.reload('5f93ec4f', component.options)
    }
    module.hot.accept("./LayoutBasic.vue?vue&type=template&id=5f93ec4f&", function () {
      api.rerender('5f93ec4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/layouts/LayoutBasic.vue"
export default component.exports